import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Megaphone, Send, Mail, Users, User, Clock, CheckCircle, AlertTriangle } from 'lucide-react';

const Comunicados = () => {
  const navigate = useNavigate();
  const [comunicados, setComunicados] = useState([]);
  const [apoderados, setApoderados] = useState([]);
  const [cargando, setCargando] = useState(false);

  const [formData, setFormData] = useState({
    titulo: '',
    mensaje: '',
    tipo: 'Informativo',
    apoderadoId: '' // Vacío = Para todos
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');
    try {
      const [resComun, resApo] = await Promise.all([
       fetch(`${process.env.REACT_APP_API_URL}/Comunicados`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${process.env.REACT_APP_API_URL}/Apoderados`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);

      if (resComun.ok) setComunicados(await resComun.json());
      if (resApo.ok) setApoderados(await resApo.json());
    } catch (e) { console.error("Error al cargar datos", e); }
  };

  const handleEnviar = async (e) => {
    e.preventDefault();
    if (!window.confirm("¿Estás seguro de enviar este comunicado? Los correos se enviarán de inmediato.")) return;

    setCargando(true);
    const token = localStorage.getItem('token');

    const payload = {
      titulo: formData.titulo,
      mensaje: formData.mensaje,
      tipo: formData.tipo,
      apoderadoId: formData.apoderadoId ? parseInt(formData.apoderadoId) : null
    };

    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/Comunicados/Enviar`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      
      if (res.ok) {
        alert(`Éxito: ${data.mensaje}`);
        setFormData({ titulo: '', mensaje: '', tipo: 'Informativo', apoderadoId: '' });
        cargarDatos();
      } else {
        alert("Hubo un error al enviar el comunicado.");
      }
    } catch (e) { alert("Error de conexión al enviar."); } finally { setCargando(false); }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />
      <main className="flex-1 p-6 overflow-y-auto">
        <header className="mb-6">
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <Megaphone className="text-blue-600" /> Centro de Comunicaciones
          </h1>
          <p className="text-slate-500 mt-1">Envía avisos a los padres de familia por correo y plataforma.</p>
        </header>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          
          {/* PANEL IZQUIERDO: REDACTAR COMUNICADO */}
          <div className="xl:col-span-1 bg-white p-6 rounded-xl shadow-sm border border-slate-200 h-fit">
            <h2 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2 border-b pb-2">
              <Send size={20} className="text-blue-500"/> Nuevo Comunicado
            </h2>
            
            
            <form onSubmit={handleEnviar} className="space-y-4" autoComplete="off">

              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Tipo de Aviso</label>
                <select value={formData.tipo} onChange={e => setFormData({...formData, tipo: e.target.value})} className="w-full p-2.5 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm font-medium">
                  <option value="Informativo">Informativo</option>
                  <option value="Cobranza">Cobranza</option>
                  <option value="Académico">Académico (Notas/Tareas)</option>
                  <option value="Urgente">Urgente</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Destinatario(s)</label>
                <div className="flex items-center gap-2 mb-2 p-2 border rounded bg-blue-50 border-blue-100 text-blue-800 text-xs font-bold">
                  {formData.apoderadoId === '' ? <Users size={16}/> : <User size={16}/>}
                  {formData.apoderadoId === '' ? 'Envío Masivo (A todos los padres)' : 'Envío Privado (A un solo padre)'}
                </div>
                <select value={formData.apoderadoId} onChange={e => setFormData({...formData, apoderadoId: e.target.value})} className="w-full p-2.5 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option value="">-- A TODOS LOS PADRES --</option>
                  {apoderados.map(apo => (
                    <option key={apo.id || apo.Id} value={apo.id || apo.Id}>
                      Solo a: {apo.apellidos || apo.Apellidos}, {apo.nombres || apo.Nombres}
                    </option>
                  ))}
                </select>
              </div>

            <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Asunto del Correo *</label>
                {/* BLINDAJE CONTRA EL NAVEGADOR AQUÍ: autoComplete="new-password" */}
                <input type="text" required autoComplete="new-password" value={formData.titulo} onChange={e => setFormData({...formData, titulo: e.target.value})} className="w-full p-2.5 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="Ej: Invitación a Reunión de Padres" />
            </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 mb-1">Mensaje *</label>
                {/* BLINDAJE EN EL TEXTAREA AQUÍ */}
                <textarea required rows="5" autoComplete="off" value={formData.mensaje} onChange={e => setFormData({...formData, mensaje: e.target.value})} className="w-full p-2.5 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm resize-none" placeholder="Escribe el contenido del correo aquí..."></textarea>
              </div>

              <button type="submit" disabled={cargando} className="w-full bg-blue-600 text-white p-3 rounded-lg font-bold hover:bg-blue-700 flex justify-center items-center gap-2 transition-colors shadow-md mt-4">
                {cargando ? 'Enviando...' : <><Mail size={18}/> Enviar Comunicado</>}
              </button>

            </form>
          </div>

          {/* PANEL DERECHO: HISTORIAL DE COMUNICADOS */}
          <div className="xl:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-fit min-h-[500px]">
            <div className="bg-slate-50 border-b p-4">
              <h2 className="font-bold text-slate-800 flex items-center gap-2"><Clock size={18} className="text-slate-500"/> Historial de Envíos</h2>
            </div>
            
            <div className="flex-1 overflow-auto p-4 space-y-4 bg-slate-50/50">
              {comunicados.length === 0 ? (
                <div className="text-center text-slate-400 py-10 font-medium">No se han enviado comunicados aún.</div>
              ) : (
                comunicados.map(com => {
                  const fecha = new Date(com.fechaEnvio || com.FechaEnvio).toLocaleString('es-PE', { dateStyle: 'medium', timeStyle: 'short' });
                  const esGlobal = !(com.apoderadoId || com.ApoderadoId);
                  const papa = com.apoderado || com.Apoderado;
                  const tipo = com.tipo || com.Tipo;

                  // Colores dinámicos según el tipo
                  let colorInsignia = 'bg-blue-100 text-blue-700';
                  if (tipo === 'Cobranza') colorInsignia = 'bg-amber-100 text-amber-700';
                  if (tipo === 'Urgente') colorInsignia = 'bg-red-100 text-red-700';
                  if (tipo === 'Académico') colorInsignia = 'bg-purple-100 text-purple-700';

                  return (
                    <div key={com.id || com.Id} className="bg-white border rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start mb-2">
                        <div className="flex gap-2 items-center">
                          <span className={`px-2.5 py-1 rounded text-[10px] font-black uppercase tracking-wider ${colorInsignia}`}>
                            {tipo}
                          </span>
                          <span className="text-xs text-slate-400 font-medium">{fecha}</span>
                        </div>
                        <div className="flex items-center gap-1 text-[10px] font-bold text-slate-500 uppercase bg-slate-100 px-2 py-1 rounded">
                          {esGlobal ? <><Users size={12}/> Global</> : <><User size={12}/> Privado</>}
                        </div>
                      </div>
                      
                      <h3 className="font-bold text-slate-800 text-lg mb-1">{com.titulo || com.Titulo}</h3>
                      
                      {!esGlobal && papa && (
                        <p className="text-xs font-bold text-slate-500 mb-2 flex items-center gap-1 border-b pb-2">
                          Para: {papa.apellidos || papa.Apellidos}, {papa.nombres || papa.Nombres}
                        </p>
                      )}

                      <p className="text-sm text-slate-600 whitespace-pre-wrap">{com.mensaje || com.Mensaje}</p>
                    </div>
                  );
                })
              )}
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

export default Comunicados;